import script from "./SourceItemsDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./SourceItemsDialog.vue?vue&type=script&setup=true&lang=ts"

import "./SourceItemsDialog.vue?vue&type=style&index=0&id=23834585&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23834585"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QSpinner,QCard,QBtn,QSpinnerDots});
